import { gql } from '@apollo/client';

export const REMOVE_PRODUCT = gql`
    mutation removeProduct($id: String!){
        removeProduct(id: $id)
    }
`;

export const CREATE_PRODUCT_AND_RECIPE = gql`
    mutation CreateProductAndRecipe(
        $product: ProductCreate!
        $recipe: RecipeCreateWithProduct
      ) {
        createProductAndRecipe(product: $product, recipe: $recipe) {
          id
          name
          priceSell
          priceBuy
          showInPos
          priceBuyCurrency {
            currencyCode
          }
          pohodaStockItemId
          categoryId
          taxId
          toGoTaxId
          printingDevices {
            id
            name
            customName
          }
        }
    }
`;

export const UPDATE_PRODUCT_AND_RECIPE = gql`
  mutation UpdateProductAndRecipe(
    $id: String!,
    $product: ProductUpdate!
    $recipe: RecipeUpdateWithProduct
  ) {
    updateProductAndRecipe(id: $id, product: $product, recipe: $recipe) {
      id
      name
      priceSell
      priceBuy
      showInPos
      priceBuyCurrency {
        currencyCode
      }
      pohodaStockItemId
      categoryId
      taxId
      toGoTaxId
      printingDevices {
        id
        name
        customName
      }
    }
  }
`;
